import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = [ 'banningId', 'banningEmail', 'banningIP', 'unbanningId', 'unbanningEmail', 'banningIPContainer', 'alsoBanIPCheckbox' ]

  banUser(event) {
    event.preventDefault()

    this.banningEmailTarget.innerText = event.params.email
    this.banningIdTarget.innerText = event.params.id
    this.alsoBanIPCheckboxTarget.checked = false
    if (event.params.ip) {
      this.banningIPContainerTarget.classList.remove('hidden')
      this.banningIPTarget.innerText = event.params.ip
    } else {
      this.banningIPContainerTarget.classList.add('hidden')
    }

    this.dispatch('showBanModal', { target: document })
  }

  async confirmBanUser(event) {
    const res = await post(`/admin/users/${this.banningIdTarget.innerText}/ban-user`, {
      body: {
        also_ban_ip: this.alsoBanIPCheckboxTarget.checked
      },
      responseKind: 'turbo-stream'
    })
  }

  unbanUser(event) {
    event.preventDefault()

    this.unbanningEmailTarget.innerText = event.params.email
    this.unbanningIdTarget.innerText = event.params.id

    this.dispatch('showUnbanModal', { target: document })
  }

  async confirmUnbanUser(event) {
    const res = await post(`/admin/users/${this.unbanningIdTarget.innerText}/unban-user`, {
      responseKind: 'turbo-stream'
    })
  }
}
